let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dZlSb")).then(() => parcelRequire('01m2L'));